import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Inbox, Sparkles, Package, FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const TYPE_LABELS = {
  quote: "Quote", bulk: "Bulk", distributor: "Distributor",
  sample: "Sample", contact: "Contact", newsletter: "Newsletter",
};

export default function Overview() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  if (!stats) return <p className="text-forest">Loading…</p>;

  const cards = [
    { label: "Total Leads", value: stats.total_leads, icon: Inbox, color: "bg-forest text-cream" },
    { label: "New Leads", value: stats.new_leads, icon: Sparkles, color: "bg-gold text-ink" },
    { label: "Products", value: stats.products, icon: Package, color: "bg-olive text-white" },
    { label: "Blog Posts", value: stats.posts, icon: FileText, color: "bg-white text-forest border border-forest/10" },
  ];

  return (
    <div data-testid="admin-overview">
      <h1 className="font-display text-3xl text-forest mb-6">Dashboard Overview</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        {cards.map((c) => (
          <div key={c.label} className={`rounded-2xl p-6 ${c.color}`} data-testid={`stat-${c.label.replace(/\s+/g, "-").toLowerCase()}`}>
            <c.icon size={24} className="mb-3 opacity-80" />
            <p className="text-3xl font-display">{c.value}</p>
            <p className="text-sm opacity-80">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl p-6 border border-forest/10">
          <h2 className="font-display text-xl text-forest mb-4">Leads by Type</h2>
          <div className="space-y-3">
            {Object.entries(stats.by_type).map(([k, v]) => (
              <div key={k} className="flex items-center justify-between">
                <span className="text-sm text-forest/80">{TYPE_LABELS[k] || k}</span>
                <div className="flex items-center gap-3 flex-1 ml-4">
                  <div className="flex-1 h-2 bg-cream rounded-full overflow-hidden">
                    <div className="h-full bg-gold" style={{ width: `${stats.total_leads ? (v / stats.total_leads) * 100 : 0}%` }} />
                  </div>
                  <span className="text-sm font-medium text-forest w-8 text-right">{v}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl p-6 border border-forest/10">
          <h2 className="font-display text-xl text-forest mb-4">Recent Enquiries</h2>
          <div className="space-y-3">
            {stats.recent.length === 0 && <p className="text-sm text-muted-foreground">No leads yet.</p>}
            {stats.recent.map((r) => (
              <div key={r.id} className="flex items-center justify-between border-b border-forest/5 pb-2">
                <div>
                  <p className="text-sm font-medium text-forest">{r.name || r.email || "Anonymous"}</p>
                  <p className="text-xs text-muted-foreground">{TYPE_LABELS[r.type] || r.type} · {r.phone || r.email}</p>
                </div>
                <Badge variant="outline" className="border-olive/40 text-olive text-xs">{r.status}</Badge>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
